







import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { State } from '../store/State';

@Component
export default class ClientReport extends Vue {
  @Prop(String) private readonly clientId!: string;

  private async created() {
    await this.$store.dispatch('bindClientReport', { clientId: this.clientId });
  }

  private destroyed() {
    this.$store.dispatch('unbindClientReport');
  }

  private get clientReport() {
    const state = this.$store.state as State;
    if (!state.clientReport || state.clientReport.length === 0) {
      return null;
    }
    return state.clientReport[0];
  }
}
